const FormCheckbox = ({
  label,
  name,
  register,
  error,
  className = "",
  ...rest
}) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <input
        type="checkbox"
        id={name}
        name={name}
        className="w-[0.85em] h-[0.85em] border-gray-300 rounded accent-[#333333] cursor-pointer hover:accent-[#000]"
        {...(register && name ? register(name) : {})}
        {...rest}
      />
      <label htmlFor={name} className="text-sm text-[#636363]">{label}</label>
      {error && <p className="text-sm text-red-500 mt-1">{error.message}</p>}
    </div>
  );
};

export default FormCheckbox;
